// Все тексты интерфейса. В компонентах строк нет (ESLint: react/jsx-no-literals);
// перевод на кыргызский — отдельный файл с тем же набором ключей.

const plural = (n: number, one: string, few: string, many: string) => {
  const a = Math.abs(n) % 100
  const b = a % 10
  if (a > 10 && a < 20) return many
  if (b === 1) return one
  if (b >= 2 && b <= 4) return few
  return many
}

export const ru = {
  app: {
    name: 'Окуу',
    tagline: 'Учёт оплат для центров, курсов и секций',
    loading: 'Загрузка…',
    skipToContent: 'К содержимому',
  },

  nav: {
    main: 'Главное меню',
    today: 'Сегодня',
    debtors: 'Должники',
    students: 'Ученики',
    groups: 'Группы',
    tariffs: 'Тарифы',
    staff: 'Сотрудники',
    import: 'Импорт',
    report: 'Отчёт',
    settings: 'Настройки',
    audit: 'Журнал',
    more: 'Ещё',
    logout: 'Выйти',
    switchCenter: 'Сменить центр',
    account: 'Аккаунт',
  },

  roles: {
    owner: 'Владелец',
    admin: 'Администратор',
    teacher: 'Преподаватель',
  } as Record<string, string>,

  common: {
    save: 'Сохранить',
    saved: 'Сохранено',
    cancel: 'Отмена',
    close: 'Закрыть',
    back: 'Назад',
    retry: 'Повторить',
    add: 'Добавить',
    create: 'Создать',
    edit: 'Изменить',
    remove: 'Удалить',
    archive: 'В архив',
    archived: 'Архив',
    showArchived: 'Показать архив',
    confirm: 'Подтвердить',
    copy: 'Скопировать',
    copied: 'Скопировано',
    search: 'Поиск',
    all: 'Все',
    loadMore: 'Показать ещё',
    optional: 'необязательно',
    none: '—',
    yes: 'Да',
    no: 'Нет',
    next: 'Дальше',
    prev: 'Назад',
    download: 'Скачать',
    details: 'Подробнее',
    actions: 'Действия',
    som: 'сом',
    reload: 'Обновить страницу',
    // «Собрано» — одно определение в «Должниках» и «Отчёте».
    collectedTip: 'Что входит в «Собрано»',
    collectedDef: 'Собрано — оплаты, отмеченные в этом месяце, за вычетом возвратов этого месяца. Отменённые операции не считаются.',
  },

  errors: {
    title: 'Не получилось',
    unknown: 'Что-то пошло не так. Попробуйте ещё раз.',
    network: 'Нет связи с сервером. Проверьте интернет.',
    noAccess: 'Нет доступа',
    noAccessText: 'У вашей роли нет доступа к этому разделу.',
    notFound: 'Не найдено',
    notFoundText: 'Страница не существует или была удалена.',
    toHome: 'На главную',
    requestId: (id: string) => `Код запроса для поддержки: ${id}`,
    required: 'Заполните поле',
    invalidPhone: 'Телефон: +996XXXXXXXXX или 0XXXXXXXXX',
    passwordMin: 'Пароль — минимум 8 символов',
    passwordMax: 'Пароль — максимум 128 символов',
    tooLong: (n: number) => `Не длиннее ${n} символов`,
    invalidAmount: 'Сумма в сомах, например 1500 или 1500,50',
    amountPositive: 'Сумма должна быть больше нуля',
    amountNonZero: 'Сумма не может быть нулевой',
    invalidNumber: 'Введите число',
    range: (min: number, max: number) => `От ${min} до ${max}`,
    tooManyAttempts: (sec?: number) =>
      sec ? `Слишком много неудачных попыток. Попробуйте через ${Math.ceil(sec / 60)} мин.` : 'Слишком много неудачных попыток. Попробуйте позже.',
    // По кодам из docs/errors.md. validation — берём сообщение сервера (оно про конкретное поле).
    codes: {
      bad_request: 'Некорректный запрос. Обновите страницу и попробуйте снова.',
      reset_not_allowed: 'Этому сотруднику пароль сбросить нельзя: он работает и в другом центре или он владелец. Обратитесь в поддержку.',
      reset_invalid: 'Ссылка для смены пароля недействительна или устарела.',
      registration_closed: 'Регистрация центров — по приглашению. Напишите нам, чтобы получить ссылку.',
      registration_invalid: 'Ссылка регистрации недействительна: она уже использована, отозвана или устарела.',
      center_pending: 'Заявка центра ещё на рассмотрении.',
      center_blocked: 'Доступ к центру приостановлен. Свяжитесь с поддержкой.',
      center_status_conflict: 'Статус центра уже другой — обновите страницу.',
      registration_link_closed: 'Ссылка уже использована или отозвана.',
      no_owner: 'У центра нет владельца — сбросить пароль некому.',
      unauthorized: 'Войдите снова — сессия закончилась.',
      bad_origin: 'Запрос отклонён. Обновите страницу.',
      forbidden: 'Недостаточно прав для этого действия.',
      not_found: 'Не найдено — возможно, уже удалено.',
      method_not_allowed: 'Действие недоступно.',
      too_large: 'Слишком большой запрос.',
      internal: 'Ошибка на сервере. Попробуйте ещё раз.',
      phone_taken: 'Этот телефон уже зарегистрирован — войдите.',
      invalid_credentials: 'Неверный телефон или пароль.',
      too_many_requests: 'Слишком много запросов. Подождите минуту.',
      invite_invalid: 'Приглашение недействительно: оно использовано, отозвано или устарело.',
      login_required: 'Этот телефон уже зарегистрирован. Войдите и примите приглашение.',
      already_member: 'Вы уже сотрудник этого центра.',
      owner_protected: 'Владельца центра нельзя изменить или удалить.',
      teacher_has_groups: 'У преподавателя есть группы — сначала назначьте им другого преподавателя.',
      tariff_in_use: 'На тариф уже записаны ученики — тип тарифа менять нельзя.',
      parent_phone_taken: 'Этот телефон уже у другого родителя в центре.',
      already_enrolled: 'Ученик уже записан в эту группу.',
      enrollment_ended: 'Запись уже завершена.',
      not_package: 'Продлить можно только абонемент.',
      student_left: 'Ученик ушёл — сначала верните ему статус.',
      telegram_not_configured: 'Telegram-бот не настроен на сервере.',
      demo_center: 'Это демо-центр: родители вымышленные, Telegram и напоминания не работают.',
      idempotency_mismatch: 'Операция уже была отправлена с другими данными. Закройте форму и откройте снова.',
      already_cancelled: 'Операция уже отменена.',
      lesson_exists: 'У группы уже есть занятие в это время.',
      lesson_cancelled: 'Занятие отменено — отметки не ставятся.',
      file_too_large: 'Файл больше 5 МБ — разбейте его на части.',
      import_already_committed: 'Этот импорт уже подтверждён.',
      import_expired: 'Предпросмотр устарел (хранится час) — загрузите файл заново.',
      already_paid: 'Эта ссылка уже оплачена.',
      provider_unavailable: 'Онлайн-оплата сейчас недоступна. Оплатите по реквизитам или попробуйте позже.',
    } as Record<string, string>,
  },

  auth: {
    loginTitle: 'Вход',
    loginLead: 'Войдите по телефону и паролю.',
    registerTitle: 'Регистрация центра',
    registerLead: 'Создайте центр — вы станете его владельцем.',
    phone: 'Телефон',
    phoneHint: 'Например, 0700 123 456',
    password: 'Пароль',
    passwordHint: 'Минимум 8 символов',
    name: 'Ваше имя',
    centerName: 'Название центра',
    submitLogin: 'Войти',
    submitRegister: 'Создать центр',
    noAccount: 'Нет аккаунта?',
    toRegister: 'Зарегистрировать центр',
    haveAccount: 'Уже есть аккаунт?',
    toLogin: 'Войти',
    logoutDone: 'Вы вышли',
    noCentersTitle: 'Нет доступных центров',
    noCentersText: 'Вас удалили из центра или приглашение ещё не принято. Попросите владельца прислать новое приглашение.',
    chooseCenter: 'Выберите центр',
    approvalLead: 'Создайте центр — вы станете его владельцем. Заявку проверит администратор сервиса, обычно в течение рабочего дня.',
    submitApplication: 'Отправить заявку',
    inviteOnlyTitle: 'Регистрация по приглашению',
    inviteOnlyText: 'Мы подключаем центры по одному и помогаем перенести данные. Напишите нам — пришлём ссылку для регистрации.',
    registerLinkInvalidTitle: 'Ссылка недействительна',
    registerLinkInvalidText: 'Ссылка регистрации уже использована, отозвана или устарела — она действует 14 дней. Напишите нам, пришлём новую.',
    writeWhatsApp: 'Написать в WhatsApp',
    whatsappRequestText: 'Здравствуйте! Хочу подключить наш центр к Окуу.',
  },

  platform: {
    title: 'Панель платформы',
    menu: 'Панель платформы',
    navLabel: 'Разделы панели',
    centers: 'Центры',
    links: 'Ссылки регистрации',
    toApp: 'В приложение',
    search: 'Поиск',
    searchHint: 'Название центра, имя или телефон владельца',
    statusLabel: 'Статус',
    statusFilter: { '': 'Все статусы', pending: 'Заявки', active: 'Активные', blocked: 'Приостановленные' } as Record<string, string>,
    status: { pending: 'Заявка', active: 'Активен', blocked: 'Приостановлен' } as Record<string, string>,
    plans: { free: 'Бесплатный', start: 'Старт', center: 'Центр', network: 'Сеть', founder: 'Основатель' } as Record<string, string>,
    col: {
      center: 'Центр',
      owner: 'Владелец',
      status: 'Статус',
      plan: 'Тариф',
      paidUntil: 'Оплачено до',
      students: 'Учеников',
      activity: 'Последний вход',
      created: 'Создан',
    },
    overdue: 'просрочено',
    demo: 'Демо',
    never: 'не входили',
    dash: '—',
    found: (n: number) => `${n} ${plural(n, 'центр', 'центра', 'центров')}`,
    empty: 'Центров не найдено',
    emptyText: 'Измените поиск или фильтр.',
    back: 'Все центры',
    about: 'О центре',
    studentsLine: (a: number, p: number, l: number) => `учатся ${a}, на паузе ${p}, ушли ${l}`,
    groups: 'Групп',
    staff: 'Сотрудников',
    telegram: 'Родителей в Telegram',
    timezone: 'Часовой пояс',
    reason: 'Причина',
    blockedReason: 'Причина приостановки',
    owner: 'Владелец',
    created: 'Создан',
    activity: 'Последний вход сотрудника',
    students: 'Ученики',
    privacyNote: 'Учеников, родителей, операции и журнал центра панель не показывает — только количество.',
    actions: 'Действия',
    approve: 'Одобрить заявку',
    block: 'Приостановить доступ',
    unblock: 'Вернуть доступ',
    ownerReset: 'Ссылка сброса пароля владельца',
    blockTitle: 'Приостановить доступ к центру',
    blockText: 'Сотрудники центра увидят «Доступ приостановлен», бот и напоминания центра остановятся. Данные сохранятся, доступ можно вернуть.',
    reasonHint: 'Видна только в панели',
    approved: 'Заявка одобрена',
    blocked: 'Доступ приостановлен',
    unblocked: 'Доступ возвращён',
    planTitle: 'Тариф и оплата',
    plan: 'Тариф',
    paidUntil: 'Оплачено до',
    paidUntilHint: 'Пусто — не задано. Просрочка только подсвечивается: центр сам не блокируется.',
    save: 'Сохранить',
    saved: 'Сохранено',
    ownerResetTitle: 'Ссылка для смены пароля',
    ownerResetLead: (name: string) => `Одноразовая, действует 24 часа. Передайте её лично: ${name}.`,
    ownerResetWa: (url: string) => `Ссылка для смены пароля в Окуу (действует 24 часа): ${url}`,
    auditTitle: 'Журнал по центру',
    auditEmpty: 'Действий пока не было.',
    console: 'консоль',
    actionNames: {
      'center.approve': 'Заявка одобрена',
      'center.block': 'Доступ приостановлен',
      'center.unblock': 'Доступ возвращён',
      'center.plan': 'Тариф или оплата',
      'center.owner_password_reset': 'Ссылка сброса пароля владельца',
      'registration_link.create': 'Ссылка регистрации создана',
      'registration_link.revoke': 'Ссылка регистрации отозвана',
      'admin.grant': 'Выданы права суперадмина',
      'admin.revoke': 'Сняты права суперадмина',
    } as Record<string, string>,
    linkCreate: 'Создать ссылку',
    linkNote: 'Для кого',
    linkNoteHint: 'Например: «Билим», Айгуль, 0700 123 456',
    linkCreatedTitle: 'Ссылка регистрации',
    linkCreatedLead: 'Одноразовая, действует 14 дней. Показывается один раз — скопируйте или отправьте сразу.',
    linkWa: (url: string) => `Здравствуйте! Ссылка для регистрации вашего центра в Окуу (действует 14 дней): ${url}`,
    linkStatus: { active: 'Действует', used: 'Использована', revoked: 'Отозвана', expired: 'Истекла' } as Record<string, string>,
    linkRevoke: 'Отозвать',
    linkRevokeTitle: 'Отозвать ссылку?',
    linkRevokeText: (note: string) => `Ссылка «${note}» перестанет работать. Создать новую можно в любой момент.`,
    linkRevoked: 'Ссылка отозвана',
    linksEmpty: 'Ссылок пока нет',
    linksEmptyText: 'Создайте ссылку и отправьте её владельцу центра — по ней он зарегистрируется.',
    linkCenter: 'Центр',
    linkExpires: (d: string) => `до ${d}`,
    linkCreated: (d: string, by: string) => `создана ${d}, ${by}`,
  },

  centerStatus: {
    pendingTitle: 'Заявка на рассмотрении',
    pendingText: (name: string) => `Центр «${name}» создан. Мы проверим заявку и откроем доступ — обычно в течение рабочего дня.`,
    blockedTitle: 'Доступ приостановлен',
    blockedText: (name: string) => `Доступ к центру «${name}» приостановлен. Свяжитесь с поддержкой, чтобы его восстановить. Данные центра сохранены.`,
    whatsappPending: (name: string) => `Здравствуйте! Я оставил(а) заявку на подключение центра «${name}» к Окуу.`,
    whatsappBlocked: (name: string) => `Здравствуйте! Доступ к центру «${name}» в Окуу приостановлен. Подскажите, что сделать?`,
    checkAgain: 'Проверить снова',
    otherCenters: 'Другие центры',
    badge: { pending: 'Заявка', blocked: 'Приостановлен', active: '' } as Record<string, string>,
  },

  statuses: {
    student: { active: 'Учится', paused: 'Пауза', left: 'Ушёл' } as Record<string, string>,
    studentFilter: { '': 'Все статусы', active: 'Учатся', paused: 'На паузе', left: 'Ушли' } as Record<string, string>,
    tg: {
      none: 'Не подключён к Telegram',
      active: 'В Telegram',
      stopped: 'Отключил уведомления',
      blocked: 'Заблокировал бота',
    } as Record<string, string>,
    tgShort: { none: 'Нет Telegram', active: 'Telegram', stopped: 'Отключил', blocked: 'Заблокировал' } as Record<string, string>,
    tgFilter: { '': 'Telegram: все', active: 'Подключены', none: 'Не подключены', stopped: 'Отключили уведомления', blocked: 'Заблокировали бота' } as Record<string, string>,
  },

  payDetails: {
    missing: 'Заполните реквизиты для оплаты — без них родители не узнают, куда платить.',
    fill: 'Заполнить в настройках',
    askOwner: 'Попросите владельца центра заполнить их в настройках.',
  },

  debtors: {
    title: 'Должники',
    markPaid: 'Отметить оплату',
    paidNotified: 'Оплата отмечена, родителю отправлено подтверждение',
    paidNoTelegram: 'Оплата отмечена, родитель не подключён к Telegram',
    collected: 'Собрано',
    collectedNote: (charged: string) => `за вычетом возвратов · начислено ${charged}`,
    totalDebt: 'Общий долг',
    totalNote: (n: number) => `${n} ${plural(n, 'ученик', 'ученика', 'учеников')} — просрочено и ожидают`,
    debt: 'Просрочено',
    debtorsCount: (n: number) => `${n} ${plural(n, 'ученик', 'ученика', 'учеников')} — срок прошёл`,
    pending: 'Ожидают оплаты',
    pendingCount: (n: number) => `${n} ${plural(n, 'ученик', 'ученика', 'учеников')} — срок ещё не наступил`,
    monthOf: (month: string) => `за ${month.toLowerCase()}`,
    allGroups: 'Все группы',
    group: 'Группа',
    overdue: (days: number) => `просрочено ${days} ${plural(days, 'день', 'дня', 'дней')}`,
    since: (date: string) => `с ${date}`,
    remind: 'Напомнить',
    remindAll: 'Напомнить всем',
    remindAllConfirm: 'Напомнить всем должникам?',
    remindAllText: 'Родителям, подключённым к Telegram, уйдёт напоминание с суммой долга. Об одном ученике — не чаще раза в час.',
    emptyTitle: 'Должников нет',
    emptyText: 'Все оплатили вовремя. Те, у кого срок ещё не наступил, — в «Ожидают оплаты».',
    emptyGroup: 'В этой группе должников нет',
    tabs: 'Списки',
    tabOverdue: 'Просрочено',
    tabPending: 'Ожидают оплаты',
    dueIn: (days: number) => (days === 0 ? 'срок сегодня' : `срок через ${days} ${plural(days, 'день', 'дня', 'дней')}`),
    dueOn: (date: string) => `до ${date}`,
    remindedToday: 'напоминали сегодня',
    remindPendingConfirm: 'Напомнить всем из «Ожидают оплаты»?',
    remindPendingText: 'Родителям, подключённым к Telegram, уйдёт напоминание с суммой к оплате. Об одном ученике — не чаще раза в час.',
    pendingEmptyTitle: 'Никто не ждёт оплаты',
    pendingEmptyText: 'Отрицательного баланса со сроком в будущем нет.',
    pendingEmptyGroup: 'В этой группе никто не ждёт оплаты',
    resultTitle: 'Напоминания',
    /** По родителям: одно сообщение — одному родителю, в нём все его дети с долгом. */
    resultSent: (parents: number, students: number) =>
      `Отправлено ${parents} ${plural(parents, 'родителю', 'родителям', 'родителям')} (учеников в ${parents === 1 ? 'сообщении' : 'сообщениях'}: ${students})`,
    resultNone: 'Никому не отправлено',
    resultSkipped: 'Не отправлено',
    reasons: {
      no_telegram: 'родитель не подключён к Telegram',
      stopped: 'родитель отключил уведомления',
      blocked: 'родитель заблокировал бота',
      rate_limited: 'уже напоминали меньше часа назад',
      no_debt: 'долга нет',
      send_failed: 'Telegram не принял сообщение',
    } as Record<string, string>,
    parentNoPhone: 'Нет родителя',
  },

  students: {
    title: 'Ученики',
    add: 'Добавить ученика',
    searchLabel: 'Поиск по ФИО или телефону',
    searchPlaceholder: 'ФИО или телефон родителя',
    filters: 'Фильтры',
    status: 'Статус',
    group: 'Группа',
    telegram: 'Telegram',
    allGroups: 'Все группы',
    noGroups: 'Без группы',
    balance: 'Баланс',
    emptyTitle: 'Пока нет учеников',
    emptyText: 'Добавьте учеников по одному или загрузите список из Excel.',
    importLink: 'Импорт из Excel',
    notFoundTitle: 'Никого не нашли',
    notFoundText: 'Измените поиск или фильтры.',
    count: (n: number) => `${n} ${plural(n, 'ученик', 'ученика', 'учеников')}`,
    showLeft: 'Показать ушедших',
  },

  studentForm: {
    title: 'Новый ученик',
    student: 'Ученик',
    fullName: 'ФИО ученика',
    fullNameHint: 'Как в журнале: фамилия и имя',
    birthDate: 'Дата рождения',
    parent: 'Родитель',
    parentName: 'Имя родителя',
    parentPhone: 'Телефон родителя',
    parentFound: (name: string, children: string[]) => `Родитель найден: ${name}${children.length ? ` (дети: ${children.join(', ')})` : ''}`,
    parentNameFound: 'Ученик будет у найденного родителя — имя можно не менять',
    discount: 'Скидка',
    discountKind: 'Скидка',
    discountKinds: { none: 'Без скидки', fixed: 'Фиксированная, сом', percent: 'Процент' } as Record<string, string>,
    discountValue: 'Размер скидки',
    discountPercentHint: 'От 0 до 100',
    discountFixedHint: 'Сумма в сомах, не больше цены тарифа',
    discountFixedMax: (price: string, tariff: string) => `Не больше цены тарифа «${tariff}»: ${price}`,
    enroll: 'Записать в группу',
    enrollHint: 'Можно сделать позже из карточки ученика',
    group: 'Группа',
    chooseGroup: 'Выберите группу',
    tariff: 'Тариф',
    tariffDefault: 'Тариф группы',
    startDate: 'Дата начала',
    firstMonth: 'За текущий месяц',
    firstMonthOptions: {
      full: 'Начислить полностью',
      manual: 'Начислить сумму вручную',
      none: 'Не начислять',
    } as Record<string, string>,
    manualAmount: 'Сумма за текущий месяц',
    /** price не задан — скидка в форме с ошибкой: сумму не обещаем. */
    packageNote: (n: number | null, price?: string) =>
      `Абонемент${n ? ` на ${n} ${plural(n, 'занятие', 'занятия', 'занятий')}` : ''}${price ? `: начислится ${price}` : ''}`,
    withDiscount: (amount: string, discount: string) => `${amount} (скидка ${discount})`,
    submit: 'Добавить ученика',
    created: 'Ученик добавлен',
    createdParentExisting: 'Ученик добавлен к уже существующему родителю',
    enrollFailed: 'Ученик добавлен, но записать в группу не получилось',
  },

  student: {
    back: 'Ученики',
    balance: 'Баланс',
    balanceDebt: 'Долг',
    balanceAdvance: 'Аванс',
    balanceZero: 'Долгов нет',
    discount: (v: string) => `Скидка: ${v}`,
    birth: (d: string) => `Дата рождения: ${d}`,
    created: (d: string) => `В центре с ${d}`,
    pay: 'Отметить оплату',
    refund: 'Возврат',
    correction: 'Поправка',
    more: 'Ещё действия',
    statusPause: 'Поставить на паузу',
    statusActive: 'Вернуть в учащиеся',
    statusLeft: 'Ученик ушёл',
    leftConfirm: 'Отметить, что ученик ушёл?',
    leftText: 'Записи в группы завершатся последним днём занятий: после него ученика не будет на занятиях и новых начислений не будет. Долг останется и будет виден в должниках.',
    leftDate: 'Последний день занятий',
    leftCancelAhead: (items: string) => `Отменить начисления за месяцы после последнего дня (${items})`,
    leftAheadItem: (month: string, amount: string) => `${month} — ${amount}`,
    leftCancelAheadHint: 'Обычная отмена с причиной «ученик ушёл» — видна в истории и журнале',
    leftDateHint: (from: string, to: string) => `С ${from} по ${to}`,
    leftDateRange: (from: string, to: string) => `Дата — с ${from} по ${to}`,
    statusChanged: 'Статус изменён',

    parent: 'Родитель',
    noParent: 'Родитель не указан',
    lastReminder: (d: string) => `Последнее напоминание: ${d}`,
    remind: 'Напомнить о долге',
    remindSent: 'Напоминание отправлено',
    remindSkipped: (reason: string) => `Не отправлено: ${reason}`,
    inviteParent: 'Пригласить в Telegram',
    reinviteParent: 'Отправить новую ссылку',
    inviteTitle: 'Приглашение в Telegram',
    inviteLead: 'Отправьте родителю ссылку: он откроет бота, согласится и поделится номером — привязка готова.',
    inviteLink: 'Ссылка на бота',
    inviteExpires: (d: string) => `Действует до ${d}`,
    copyLink: 'Скопировать ссылку',
    copyText: 'Скопировать текст',
    whatsapp: 'Отправить в WhatsApp',
    inviteText: 'Текст сообщения',
    inviteLang: { ru: 'Русский', ky: 'Кыргызча' } as Record<string, string>,
    inviteLangLabel: 'Язык сообщения',

    enrollments: 'Группы',
    enrollmentsEmpty: 'Не записан ни в одну группу',
    addEnrollment: 'Записать в группу',
    enrollTitle: 'Запись в группу',
    enrolled: 'Записан в группу',
    since: (d: string) => `с ${d}`,
    until: (d: string) => `по ${d}`,
    ended: 'Завершена',
    lessonsLeft: (n: number) => (n > 0 ? `Осталось ${n} ${plural(n, 'занятие', 'занятия', 'занятий')}` : n === 0 ? 'Абонемент закончился' : `Абонемент в минусе: ${n}`),
    billedThrough: (m: string) => `Начислено по ${m.toLowerCase()}`,
    tariffKinds: { monthly: 'месяц', package: 'абонемент' } as Record<string, string>,
    end: 'Завершить',
    endTitle: 'Завершить запись?',
    endText: 'Ученик больше не будет в этой группе. Начисления по ней прекратятся.',
    endDate: 'Дата завершения',
    endDone: 'Запись завершена',
    renew: 'Продлить абонемент',
    renewTitle: 'Продлить абонемент?',
    renewText: (price: string, n: number | null) =>
      `Начислится ${price}${n ? `, к остатку добавится ${n} ${plural(n, 'занятие', 'занятия', 'занятий')}` : ''}.`,
    renewDone: 'Абонемент продлён',

    history: 'История операций',
    historyEmpty: 'Операций пока нет',
    kinds: { charge: 'Начисление', payment: 'Оплата', refund: 'Возврат', correction: 'Поправка' } as Record<string, string>,
    methods: { cash: 'наличные', transfer: 'перевод', card: 'карта', finik: 'Finik' } as Record<string, string>,
    period: (m: string) => `за ${m.toLowerCase()}`,
    due: (d: string) => `срок ${d}`,
    cancelled: 'Отменено',
    cancelledReason: (r: string) => `Отменено: ${r}`,
    system: 'система',
    cancel: 'Отменить',
    cancelTitle: 'Отменить операцию?',
    cancelText: 'Операция не удаляется — она остаётся в истории с пометкой и причиной и перестаёт влиять на баланс.',
    cancelReason: 'Причина отмены',
    cancelReasonHint: 'Обязательно, от 3 символов',
    cancelDone: 'Операция отменена',
    reasonMin: 'Причина — от 3 символов',

    attendance: 'Посещения',
    attendanceEmpty: 'В этом месяце отметок нет',
    attendanceSummary: (p: number, a: number, e: number) => `Был ${p} · не был ${a} · уважительная ${e}`,
    deducted: 'списано с абонемента',
    marks: { present: 'Был', absent: 'Не был', excused: 'Уважит.' } as Record<string, string>,
  },

  operation: {
    titles: { payment: 'Оплата', refund: 'Возврат', correction: 'Поправка' } as Record<string, string>,
    amount: 'Сумма',
    method: 'Способ',
    methods: { cash: 'Наличные', transfer: 'Перевод', card: 'Карта' } as Record<string, string>,
    comment: 'Комментарий',
    commentRequired: 'Причина поправки',
    direction: 'Что сделать',
    directions: { debit: 'Добавить к долгу', credit: 'Уменьшить долг' } as Record<string, string>,
    refundHint: 'Возврат уменьшает баланс ученика',
    correctionHint: 'Например, перерасчёт за болезнь или ошибка в начислении',
    submit: { payment: 'Отметить оплату', refund: 'Оформить возврат', correction: 'Сохранить поправку' } as Record<string, string>,
    done: { payment: 'Оплата отмечена', refund: 'Возврат оформлен', correction: 'Поправка сохранена' } as Record<string, string>,
    commentReq: 'Укажите причину поправки',
  },

  today: {
    title: 'Сегодня',
    prevDay: 'Предыдущий день',
    nextDay: 'Следующий день',
    toToday: 'Сегодня',
    pickDate: 'Дата',
    dayTitle: (weekday: string, date: string) => `${weekday[0]?.toUpperCase() ?? ''}${weekday.slice(1)}, ${date}`,
    windowTeacher: 'Отмечать можно за последние 7 дней',
    emptyTitle: 'Занятий нет',
    emptyText: 'В этот день нет занятий по расписанию.',
    emptyTextAdmin: 'В этот день нет занятий по расписанию. Можно добавить внеплановое.',
    noStudents: 'В группе нет учеников',
    marked: (m: number, n: number) => `Отмечено ${m} из ${n}`,
    unscheduled: 'внеплановое',
    cancelled: 'Занятие отменено',
    cancelledHint: 'Отменённое занятие ничего не списывает',
    marks: { present: 'Был', absent: 'Не был', excused: 'Уважит.' } as Record<string, string>,
    marksFull: { present: 'Был', absent: 'Не был', excused: 'Уважительная причина' } as Record<string, string>,
    allPresent: 'Все были',
    save: 'Сохранить',
    saved: 'Отметки сохранены',
    nothingToSave: 'Нет изменений',
    unsaved: (n: number) => `${n} ${plural(n, 'изменение', 'изменения', 'изменений')} не сохранено`,
    leaveTitle: 'Отметки не сохранены',
    leaveText: 'Если перейти на другой день, несохранённые отметки пропадут.',
    leaveConfirm: 'Перейти без сохранения',
    lessonsLeft: (n: number) => (n > 0 ? `осталось ${n}` : n === 0 ? 'абонемент закончился' : `абонемент в минусе: ${n}`),
    hasDebt: 'долг',
    lessonMenu: 'Действия с занятием',
    cancelLesson: 'Отменить занятие',
    cancelLessonTitle: 'Отменить занятие?',
    cancelLessonText: 'Например, праздник. Отметки снимутся, с абонементов ничего не спишется.',
    restoreLesson: 'Вернуть занятие',
    lessonCancelled: 'Занятие отменено',
    lessonRestored: 'Занятие возвращено',
    addLesson: 'Внеплановое занятие',
    addLessonTitle: 'Внеплановое занятие',
    addLessonText: (date: string) => `Дата: ${date}`,
    time: 'Начало',
    lessonAdded: 'Занятие добавлено',
  },

  groups: {
    title: 'Группы',
    add: 'Создать группу',
    edit: 'Изменить группу',
    createTitle: 'Новая группа',
    editTitle: 'Группа',
    name: 'Название',
    namePlaceholder: 'Например, Английский A1',
    teacher: 'Преподаватель',
    noTeacher: 'Без преподавателя',
    schedule: 'Расписание',
    scheduleHint: 'Отметьте дни и время занятий',
    noSchedule: 'Без расписания',
    from: 'с',
    to: 'до',
    startLabel: (day: string) => `${day}: начало`,
    endLabel: (day: string) => `${day}: конец`,
    timeOrder: 'Конец должен быть позже начала',
    tariff: 'Тариф по умолчанию',
    noTariff: 'Без тарифа',
    archivedTariff: 'Тариф в архиве',
    tariffHint: 'Подставляется при записи ученика',
    students: (n: number) => `${n} ${plural(n, 'ученик', 'ученика', 'учеников')}`,
    emptyTitle: 'Групп пока нет',
    emptyText: 'Создайте группу: название, преподаватель, дни и время занятий.',
    emptyTeacher: 'Вам пока не назначены группы',
    emptyArchive: 'В архиве пусто',
    created: 'Группа создана',
    saved: 'Группа сохранена',
    archiveTitle: 'Отправить группу в архив?',
    archiveText: 'Новых занятий по расписанию не будет. Записи учеников и история останутся.',
    archived: 'Группа в архиве',
    members: 'Состав группы',
    membersEmpty: 'В группе пока никого',
    back: 'Группы',
    noTariffs: 'Сначала создайте тариф — без него нельзя записать ученика.',
  },

  tariffs: {
    title: 'Тарифы',
    add: 'Создать тариф',
    createTitle: 'Новый тариф',
    editTitle: 'Тариф',
    name: 'Название',
    namePlaceholder: 'Например, Английский — месяц',
    kind: 'Тип',
    kinds: { monthly: 'В месяц', package: 'Абонемент' } as Record<string, string>,
    kindHints: { monthly: 'Фиксированная сумма каждый месяц', package: 'Сумма за N занятий' } as Record<string, string>,
    price: 'Цена',
    lessons: 'Занятий в абонементе',
    perMonth: 'в месяц',
    perPackage: (n: number) => `за ${n} ${plural(n, 'занятие', 'занятия', 'занятий')}`,
    priceHint: 'Новая цена — со следующего начисления',
    emptyTitle: 'Тарифов пока нет',
    emptyText: 'Тариф — цена обучения: в месяц или абонемент на N занятий.',
    emptyArchive: 'В архиве пусто',
    created: 'Тариф создан',
    saved: 'Тариф сохранён',
    archiveTitle: 'Отправить тариф в архив?',
    archiveText: 'Новых учеников на него не записать. Текущие записи и начисления останутся.',
    archived: 'Тариф в архиве',
  },

  staff: {
    title: 'Сотрудники',
    invite: 'Пригласить',
    inviteTitle: 'Пригласить сотрудника',
    inviteLead: 'Ссылка действует 7 дней и работает один раз.',
    role: 'Роль',
    roleHints: {
      admin: 'Ученики, оплаты, группы, посещаемость',
      teacher: 'Только «Сегодня» и свои группы, без денег',
    } as Record<string, string>,
    name: 'Кого приглашаете',
    nameHint: 'Имя увидит сотрудник на странице приглашения',
    create: 'Создать ссылку',
    linkTitle: 'Ссылка-приглашение',
    linkLead: 'Отправьте её сотруднику. Ссылка показывается один раз — потом создайте новую.',
    link: 'Ссылка',
    copyLink: 'Скопировать ссылку',
    whatsapp: 'Отправить в WhatsApp',
    whatsappText: (center: string, url: string) => `Приглашение в «${center}» в Окуу: ${url}`,
    you: 'вы',
    changeRole: 'Сменить роль',
    makeRole: (role: string) => `Сделать: ${role.toLowerCase()}`,
    roleChanged: 'Роль изменена',
    remove: 'Удалить из центра',
    removeTitle: (name: string) => `Удалить ${name} из центра?`,
    removeText: 'Сотрудник потеряет доступ к центру. Его действия останутся в журнале.',
    removed: 'Сотрудник удалён',
    invites: 'Ожидают принятия',
    invitesEmpty: 'Все приглашения приняты — ожидающих нет',
    inviteFor: (role: string, name: string | null) => (name ? `${name} · ${role.toLowerCase()}` : role),
    noName: 'Без имени',
    expires: (d: string) => `до ${d}`,
    reissue: 'Новая ссылка',
    reissueLabel: (who: string) => `Новая ссылка: ${who}`,
    revokeLabel: (who: string) => `Отозвать: ${who}`,
    reissuedLead: 'Старая ссылка больше не работает. Отправьте сотруднику эту — она показывается один раз.',
    revoke: 'Отозвать',
    revokeTitle: 'Отозвать приглашение?',
    revokeText: 'Ссылка перестанет работать.',
    revoked: 'Приглашение отозвано',
    readOnly: 'Приглашать и менять роли может владелец.',
    menu: (name: string) => `Действия: ${name}`,
  },

  invite: {
    title: 'Приглашение',
    lead: (center: string, role: string) => `Вас приглашают в «${center}» — ${role.toLowerCase()}.`,
    forName: (name: string) => `Приглашение для: ${name}`,
    expires: (d: string) => `Действует до ${d}`,
    accept: 'Принять приглашение',
    acceptAs: (name: string) => `Вы вошли как ${name}.`,
    notYou: 'Это не вы? Выйти',
    newUser: 'Создайте аккаунт',
    newUserLead: 'Телефон и пароль — для входа в Окуу.',
    haveAccount: 'Уже есть аккаунт?',
    login: 'Войти и принять',
    invalidTitle: 'Приглашение недействительно',
    invalidText: 'Ссылка использована, отозвана или устарела. Попросите владельца центра прислать новую.',
    loginRequired: 'Этот телефон уже зарегистрирован. Войдите — и приглашение примется.',
    alreadyMember: 'Вы уже сотрудник этого центра.',
    toCenter: 'Перейти в центр',
    accepted: 'Приглашение принято',
  },

  import: {
    title: 'Импорт из Excel',
    lead: 'Загрузите список учеников из Excel или CSV: ученики, родители, группы, тарифы и начальный долг.',
    step1: 'Скачайте шаблон',
    step1Text: 'В шаблоне — колонки и пример строки, на листе «Справка» — ваши группы и тарифы.',
    template: 'Скачать шаблон',
    step2: 'Загрузите заполненный файл',
    step2Text: '.xlsx или .csv, до 5 МБ и 2000 строк.',
    file: 'Файл',
    choose: 'Выбрать файл',
    upload: 'Проверить файл',
    uploading: 'Проверяем…',
    noFile: 'Выберите файл',
    tooLarge: 'Файл больше 5 МБ',
    previewTitle: 'Проверка файла',
    summary: (total: number) => `Строк в файле: ${total}`,
    ok: 'без замечаний',
    warning: 'с предупреждениями',
    error: 'с ошибками',
    skipped: 'дубликаты',
    toImport: (n: number) => `Будет загружено: ${n} ${plural(n, 'ученик', 'ученика', 'учеников')}`,
    errorsNote: 'Строки с ошибками не загрузятся. Исправьте их в файле и загрузите снова — или загрузите остальные.',
    expires: (d: string) => `Проверка действует до ${d}`,
    filter: 'Показать',
    filters: { all: 'Все строки', problems: 'С замечаниями', error: 'Ошибки' } as Record<string, string>,
    cols: {
      row: 'Строка',
      student: 'Ученик',
      parent: 'Родитель',
      group: 'Группа и тариф',
      debt: 'Долг',
      status: 'Статус',
    },
    rowStatus: { ok: 'OK', warning: 'Предупреждение', error: 'Ошибка', skip: 'Дубликат' } as Record<string, string>,
    newGroup: 'новая группа',
    noTariff: 'тариф не найден',
    lessonsLeft: (n: number) => `осталось ${n} ${plural(n, 'занятие', 'занятия', 'занятий')}`,
    since: (d: string) => `с ${d}`,
    firstMonth: 'За текущий месяц',
    firstMonthOptions: {
      full: 'Начислить по тарифу',
      none: 'Не начислять (уже оплачено или учтено в долге)',
    } as Record<string, string>,
    firstMonthHint: 'Для месячных тарифов. Абонементы с остатком занятий не начисляются.',
    commit: (n: number) => `Загрузить ${n} ${plural(n, 'ученика', 'ученика', 'учеников')}`,
    again: 'Загрузить другой файл',
    nothing: 'Нечего загружать: все строки с ошибками или дубликаты.',
    expired: 'Проверка устарела — загрузите файл ещё раз.',
    resultTitle: 'Импорт завершён',
    result: {
      students: (n: number) => `${n} ${plural(n, 'ученик', 'ученика', 'учеников')}`,
      parents: (n: number) => `${n} ${plural(n, 'родитель', 'родителя', 'родителей')}`,
      groups: (n: number) => `${n} ${plural(n, 'новая группа', 'новые группы', 'новых групп')}`,
      enrollments: (n: number) => `${n} ${plural(n, 'запись', 'записи', 'записей')} в группы`,
      skipped: (n: number) => `${n} ${plural(n, 'дубликат пропущен', 'дубликата пропущено', 'дубликатов пропущено')}`,
      debt: (sum: string) => `Начальный долг: ${sum}`,
    },
    toStudents: 'К ученикам',
    toDebtors: 'К должникам',
    more: 'Загрузить ещё',
  },

  report: {
    title: 'Отчёт',
    download: 'Скачать Excel',
    period: (from: string, to: string) => `${from} — ${to}`,
    charged: 'Начислено',
    collected: 'Собрано',
    collectedNote: 'за вычетом возвратов — как в «Должниках»',
    byMethod: 'По способам оплаты',
    methods: { cash: 'Наличные', transfer: 'Перевод', card: 'Карта', finik: 'Онлайн (Finik)' } as Record<string, string>,
    paidIn: 'Поступило оплат',
    refunds: 'Возвраты',
    collectedNet: 'Собрано (за вычетом возвратов)',
    corrections: 'Поправки',
    debtEnd: 'Долг на конец месяца',
    debtors: (n: number) => `${n} ${plural(n, 'должник', 'должника', 'должников')}`,
    students: 'Ученики',
    active: 'Учатся на конец месяца',
    joined: 'Пришли',
    left: 'Ушли',
    downloaded: 'Файл скачан',
  },

  settings: {
    title: 'Настройки',
    center: 'Центр',
    name: 'Название центра',
    phone: 'Телефон центра',
    phoneHint: 'Для родителей — в сообщениях бота',
    timezone: 'Часовой пояс',
    billing: 'Начисления и оплата',
    billingDay: 'День начисления',
    billingDayHint: 'Каждый месяц в этот день начисляется плата по месячным тарифам (1–28)',
    billingDayNext: (day: number, from: string) => `День начисления изменится с ${from}: ${day}-е число`,
    billingDayChange: 'Новый день начисления начнёт действовать со следующего месяца — текущий месяц не изменится',
    dueDays: 'Срок оплаты, дней',
    dueDaysHint: 'Сколько дней после начисления есть на оплату (0–60). Потом — долг.',
    attendance: 'Посещаемость',
    excusedDeducts: '«Уважительная» списывает занятие с абонемента',
    excusedDeductsHint: 'Если выключено — пропуск по уважительной причине не тратит занятие',
    notifications: 'Уведомления родителям',
    remindersOn: 'Автонапоминания о долге',
    remindersOnHint: 'Бот напомнит родителю в Telegram о сроке и о долге',
    notifyAbsent: 'Сообщать «не был на занятии»',
    overdueRepeat: 'После 7-го дня просрочки',
    overdueRepeatOptions: { weekly: 'Напоминать раз в неделю, пока не оплатят', off: 'Больше не напоминать (только вручную)' },
    overdueRepeatHint: 'Бот напоминает за 3 дня, в день срока, на 3-й и 7-й день просрочки; дальше — по этой настройке (14, 21, 28… день). Не чаще раза в день, с 9:00 до 20:00.',
    overdueRepeatOffHint: 'Автонапоминания выключены',
    payment: 'Оплата',
    payDetails: 'Реквизиты и инструкция для оплаты',
    payDetailsHint: 'Бот присылает этот текст родителю в напоминании о долге и по кнопке «Как оплатить» — как есть, с переносами строк.',
    payDetailsPlaceholder:
      'Оплата на MBank: 0700 123 456 (Имя Ф.).\nПосле оплаты отправьте чек с ФИО ученика и суммой администратору в WhatsApp: +996 700 123 456.',
    payDetailsCounter: (n: number, max: number) => `${n} / ${max}`,
    previewTitle: 'Так увидит родитель в Telegram',
    previewNote: 'Пример напоминания о долге: сумма и срок — для примера.',
    // Повторяет текст бота (backend/internal/notify/texts_ru.go: DebtReminder, HowToPay) — меняйте вместе.
    preview: {
      header: (center: string) => `🏫 Центр «${center}»: напоминание об оплате.`,
      child: '• Асанов Бакыт — 3 500 сом, срок до 05.11',
      howToPay: 'Как оплатить:',
      missing: 'Уточните способ оплаты у администратора центра.',
      footer: 'Если вы уже оплатили, не обращайте внимания: администратор отметит оплату, и бот пришлёт подтверждение.',
      button: 'Баланс и посещения',
    },
    finik: 'Онлайн-оплата (Finik)',
    finikOn: 'Подключена',
    finikOff: 'Не подключена — родители платят по реквизитам',
    plan: 'Тариф Окуу',
    saved: 'Настройки сохранены',
    noChanges: 'Нет изменений',
    readOnly: 'Изменять настройки может владелец.',
  },

  audit: {
    title: 'Журнал действий',
    who: 'Сотрудник',
    allStaff: 'Все сотрудники',
    type: 'Тип',
    allTypes: 'Все действия',
    from: 'С даты',
    to: 'По дату',
    emptyTitle: 'Записей нет',
    emptyText: 'Измените фильтры.',
    system: 'Система',
    details: 'Подробнее',
    before: 'Было',
    after: 'Стало',
    field: 'Поле',
    value: 'Значение',
    techData: 'Технические данные',
    noChanges: 'Без изменений в видимых полях — см. технические данные',
    yes: 'да',
    no: 'нет',
    empty: '—',
    notMarked: 'не отмечен',
    sep: ', ',
    studentsCount: (n: number) => `${n} ${plural(n, 'ученик', 'ученика', 'учеников')}`,
    cancelledOp: (kind: string, amount: string) => `${kind} ${amount}`,
    lessonLine: (group: string, date: string) => `${group} · ${date}`,
    /** Подписи полей before/after (ключи — как пишет бэкенд в audit_log). name — по сущности: nameOf. */
    fields: {
      amount: 'Сумма',
      kind: 'Вид',
      method: 'Способ',
      comment: 'Комментарий',
      list_price: 'Цена по тарифу',
      discount: 'Скидка',
      discount_capped: 'Скидка урезана до цены',
      period: 'За месяц',
      due_date: 'Срок оплаты',
      cancelled: 'Отменено',
      reason: 'Причина',
      full_name: 'ФИО',
      birth_date: 'Дата рождения',
      status: 'Статус',
      parent_existing: 'Родитель уже был в базе',
      phone: 'Телефон',
      timezone: 'Часовой пояс',
      billing_day: 'День начисления',
      billing_day_next: 'Новый день начисления',
      billing_day_next_from: 'Новый день начисления — с',
      due_days: 'Дней на оплату',
      excused_deducts: 'Уважительная причина списывает занятие',
      reminders_on: 'Автонапоминания',
      overdue_repeat: 'После 7-го дня просрочки',
      notify_absent: 'Сообщать родителю о пропуске',
      pay_details: 'Реквизиты',
      schedule: 'Расписание',
      price: 'Цена',
      lessons_count: 'Занятий в абонементе',
      archived: 'В архиве',
      role: 'Роль',
      expires_at: 'Действует до',
      revoked: 'Отозвано',
      new_user: 'Новый пользователь',
      start_date: 'Дата начала',
      end_date: 'Дата окончания',
      lessons_left: 'Осталось занятий',
      first_month: 'За текущий месяц',
      manual_amount: 'Сумма за текущий месяц',
      billed_through: 'Начислено по',
      package_imported: 'Остаток абонемента из импорта',
      date: 'Дата',
      start_time: 'Начало',
      marks: 'Отметки',
      returned_lessons: 'Возвращено занятий в абонементы',
      students_created: 'Учеников добавлено',
      parents_created: 'Родителей добавлено',
      groups_created: 'Групп добавлено',
      enrollments_created: 'Записей в группы',
      skipped: 'Пропущено',
      debt_total: 'Долг из файла',
      all: 'Всем должникам',
      sent: 'Напомнили',
      messages: 'Сообщений родителям',
      tg_status: 'Telegram',
      consent_at: 'Согласие получено',
      lang: 'Язык',
      link_amount: 'Сумма по ссылке',
      paid_amount: 'Оплачено',
      sessions_closed: 'Закрыто сеансов',
      other_sessions_closed: 'Закрыто других сеансов',
      by: 'Кто выдал',
    } as Record<string, string>,
    /** «name» у группы, тарифа и центра — название, у остальных (сотрудник, приглашение, родитель) — имя. */
    nameOf: (entity: string) => (['group', 'tariff', 'center'].includes(entity) ? 'Название' : 'Имя'),
    /** Значения-коды по полю. */
    values: {
      kind: {
        charge: 'Начисление',
        payment: 'Оплата',
        refund: 'Возврат',
        correction: 'Поправка',
        monthly: 'В месяц',
        package: 'Абонемент',
        parent: 'Родитель',
      },
      method: { cash: 'Наличные', transfer: 'Перевод', card: 'Карта', finik: 'Онлайн (Finik)' },
      status: { active: 'Учится', paused: 'Пауза', left: 'Ушёл' },
      role: { owner: 'Владелец', admin: 'Администратор', teacher: 'Преподаватель' },
      tg_status: { active: 'Подключён', stopped: 'Отключил уведомления', blocked: 'Заблокировал бота', none: 'Не подключён' },
      first_month: { full: 'Начислить полностью', manual: 'Сумма вручную', none: 'Не начислять' },
      overdue_repeat: { weekly: 'Напоминать раз в неделю', off: 'Больше не напоминать' },
      lang: { ru: 'Русский', ky: 'Кыргызча' },
      reason: { 'student.left': 'Ученик ушёл' },
      by: { support: 'Поддержка Окуу' },
      mark: { present: 'Был', absent: 'Не был', excused: 'Уважительная причина' },
    } as Record<string, Record<string, string>>,
    types: {
      'ledger.': 'Деньги',
      'attendance.': 'Посещаемость',
      'student.': 'Ученики',
      'enrollment.': 'Записи в группы',
      'parent.': 'Родители',
      'group.': 'Группы',
      'tariff.': 'Тарифы',
      'lesson.': 'Занятия',
      'staff.': 'Сотрудники',
      'invite.': 'Приглашения',
      'import.': 'Импорт',
      'center.': 'Настройки',
      'reminder.': 'Напоминания',
      'payment.': 'Онлайн-оплата',
      'user.': 'Аккаунты сотрудников',
    } as Record<string, string>,
    actions: {
      'invite.create': 'Приглашение создано',
      'invite.revoke': 'Приглашение отозвано',
      'invite.reissue': 'Новая ссылка приглашения',
      'invite.accept': 'Приглашение принято',
      'staff.role_change': 'Роль изменена',
      'staff.remove': 'Сотрудник удалён',
      'tariff.create': 'Тариф создан',
      'tariff.update': 'Тариф изменён',
      'tariff.archive': 'Тариф в архиве',
      'group.create': 'Группа создана',
      'group.update': 'Группа изменена',
      'group.archive': 'Группа в архиве',
      'student.create': 'Ученик добавлен',
      'student.update': 'Ученик изменён',
      'parent.update': 'Родитель изменён',
      'parent.telegram_link': 'Родитель подключил Telegram',
      'parent.telegram_stop': 'Родитель отключил уведомления',
      'parent.telegram_resume': 'Родитель включил уведомления',
      'enrollment.create': 'Запись в группу',
      'enrollment.end': 'Запись завершена',
      'enrollment.renew': 'Абонемент продлён',
      'ledger.charge': 'Начисление',
      'ledger.payment': 'Оплата',
      'ledger.refund': 'Возврат',
      'ledger.correction': 'Поправка',
      'ledger.cancel': 'Операция отменена',
      'lesson.create': 'Внеплановое занятие',
      'lesson.cancel': 'Занятие отменено',
      'lesson.restore': 'Занятие возвращено',
      'attendance.mark': 'Отметки посещаемости',
      'import.commit': 'Импорт из Excel',
      'center.update': 'Настройки изменены',
      'reminder.manual': 'Напоминание о долге',
      'payment.amount_mismatch': 'Онлайн-оплата: сумма не совпала',
      'user.password_change': 'Пароль изменён',
      'user.logout_all': 'Выход на всех устройствах',
      'user.password_reset_issue': 'Ссылка для смены пароля выдана',
      'user.password_reset_done': 'Пароль изменён по ссылке',
    } as Record<string, string>,
  },

  pay: {
    title: 'Оплата обучения',
    loading: 'Загружаем…',
    student: 'Ученик',
    amount: 'К оплате',
    expires: (d: string) => `Ссылка действует до ${d}`,
    payOnline: 'Оплатить онлайн',
    opening: 'Открываем банк…',
    openBank: 'Перейти к оплате',
    manualTitle: 'Как оплатить',
    manualText: 'Переведите сумму по реквизитам ниже и укажите ФИО ученика. Оплату отметит администратор центра.',
    details: 'Реквизиты',
    copyDetails: 'Скопировать реквизиты',
    noDetails: 'Центр ещё не указал реквизиты — уточните у администратора.',
    paidTitle: 'Оплата получена',
    paidText: 'Спасибо! Центр уже видит оплату.',
    expiredTitle: 'Ссылка устарела',
    expiredText: 'Ссылка больше не действует. Уточните способ оплаты у администратора центра.',
    offlineTitle: 'Онлайн-оплата не подключена',
    offlineText: 'Онлайн-оплата не подключена, уточните способ оплаты у администратора центра.',
    providerDown: 'Онлайн-оплата сейчас недоступна. Попробуйте позже или оплатите по реквизитам центра.',
    refresh: 'Проверить оплату',
  },

  studentEdit: {
    action: 'Изменить данные',
    title: 'Данные ученика',
    saved: 'Данные сохранены',
    phoneHint: 'Новый телефон отключит родителя от Telegram — нужно будет пригласить снова. Родитель общий у всех его детей.',
    discountNote: 'Новая скидка действует со следующего начисления.',
  },

  account: {
    title: 'Профиль',
    menu: 'Профиль',
    back: 'Назад',
    profile: 'Личные данные',
    name: 'Имя',
    nameHint: 'Так вас видят в списке сотрудников и в журнале действий',
    nameSaved: 'Имя сохранено',
    phone: 'Телефон',
    phoneHint: 'Телефон — логин для входа. Сменить его может поддержка.',
    centers: 'Центры',
    open: 'Открыть',
    password: 'Пароль',
    passwordText: 'После смены пароля на других устройствах нужно будет войти заново.',
    changePassword: 'Сменить пароль',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    repeatPassword: 'Повторите новый пароль',
    passwordsDiffer: 'Пароли не совпадают',
    samePassword: 'Новый пароль совпадает с текущим',
    passwordChanged: 'Пароль изменён. На других устройствах нужно войти заново.',
    sessions: 'Устройства',
    sessionsText: 'Если вы входили с чужого телефона или компьютера — выйдите везде. Войти снова можно с паролем.',
    logoutAll: 'Выйти на всех устройствах',
    logoutAllTitle: 'Выйти на всех устройствах?',
    logoutAllText: 'Сессии на всех телефонах и компьютерах закроются, включая этот. Войти снова — по телефону и паролю.',
    loggedOutAll: 'Вы вышли на всех устройствах',
  },

  reset: {
    title: 'Новый пароль',
    lead: (name: string, center: string | null) => (center ? `${name}, центр «${center}».` : `${name}.`),
    text: 'Придумайте новый пароль. После смены войдите с ним на всех устройствах.',
    submit: 'Сохранить пароль',
    doneTitle: 'Пароль изменён',
    doneText: 'Войдите с новым паролем.',
    toLogin: 'Войти',
    invalidTitle: 'Ссылка недействительна',
    invalidText: 'Ссылка устарела (действует 24 часа), заменена новой или уже использована. Попросите владельца центра прислать новую.',
  },

  staffReset: {
    action: 'Сбросить пароль',
    title: 'Ссылка для смены пароля',
    lead: (name: string) => `Отправьте ссылку сотруднику (${name}). Она работает один раз; все его сессии закроются после смены пароля.`,
    expires: (d: string) => `Действует до ${d}`,
    whatsappText: (center: string, url: string) => `Ссылка для смены пароля в Окуу («${center}»): ${url}`,
  },

  share: {
    link: 'Ссылка',
    copy: 'Скопировать ссылку',
    whatsapp: 'Отправить в WhatsApp',
  },

  month: {
    prev: 'Предыдущий месяц',
    next: 'Следующий месяц',
  },

  ui: {
    dialogClose: 'Закрыть',
    toastRegion: 'Уведомления',
    loading: 'Загрузка',
    paused: 'пауза',
    left: 'ушёл',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
  },

  plural,
}

export type Ru = typeof ru
